import DocsAsCodeForWriters from './posts/DocsAsCodeForWriters';
import AiPromptsForTechnicalWriters from './posts/AiPromptsForTechnicalWriters';

export const postComponents: Record<string, React.ComponentType> = {
  'docs-as-code-for-writers': DocsAsCodeForWriters,
  'ai-prompts-for-technical-writers': AiPromptsForTechnicalWriters,
};
